import React from 'react';

import { PostOfficeSideNavMessageProvider } from '@post-office/placements--growth/confluence-side-nav/contexts/post-office-side-nav-message-provider';

import { RightSidebarContextProvider } from '@confluence/page-layout-context';
import { InProductHelpProvider } from '@confluence/in-product-help/entry-points/InProductHelpProvider.ts';
import { SnippetsProvider } from '@confluence/snippets/entry-points/SnippetsProvider.ts';
import { ApprovalsProvider } from '@confluence/approvals/entry-points/ApprovalsContext.ts';

type PageLayoutContextProviderWrapperPropsType = {
	children: React.ReactNode;
};

export const PageLayoutContextProviderWrapper = ({
	children,
}: PageLayoutContextProviderWrapperPropsType): React.JSX.Element => {
	return (
		<RightSidebarContextProvider>
			<PostOfficeSideNavMessageProvider>
				<InProductHelpProvider>
					<SnippetsProvider>
						<ApprovalsProvider>{children}</ApprovalsProvider>
					</SnippetsProvider>
				</InProductHelpProvider>
			</PostOfficeSideNavMessageProvider>
		</RightSidebarContextProvider>
	);
};
